import React, { useState } from "react";
import PropTypes from "prop-types";
import FlagIcon from '@material-ui/icons/Flag';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import DialogContent from "@material-ui/core/DialogContent";
import styles from './StudyBrowserDetail.module.scss'
import { Typography } from "@material-ui/core";
import { utilFunctions } from "../../../_helpers";

const OperationGroup = (props) => {
    // const classes = useStyles();

    return (
        <div key={props.uniqueKey} className={styles.operationGroup}>
            <h2>{props.groupName}</h2>
            {props.data.map((item) => {
                return (
                    <div key={item.id} className={styles.operationGroupItem}>
                        <span>CT {item.operationId}</span>
                        <span>{utilFunctions.formatCycleTimes(item.cycleTime)}</span>
                        {item.isFlagged ? <span className="textRight"><FlagIcon color={"error"} /></span> : <span />}
                        {item.isCancelled ? <span className="textRight"><RadioButtonUncheckedIcon /></span> : <span className="textRight"><CheckCircleIcon /></span>}
                    </div>
                )
            })}
        </div>
    )
}

const StudyBrowserDetail = (props) => {

    return (
        <DialogContent>
            {!!props.data && props.data.map((operationGroup, index) => {
                return (
                    <OperationGroup
                        key={index}
                        uniqueKey={index}
                        data={operationGroup.operations || []}
                        groupName={operationGroup.groupName} />
                )
            })}
            {props.data.length == 0 && <Typography className="uppercase fontSizePrimary">No Study Details Found.</Typography>}
        </DialogContent>
    )
}

StudyBrowserDetail.propTypes = {
    data: PropTypes.array
}
StudyBrowserDetail.defaultProps = {
    data: []
}

export default StudyBrowserDetail
